import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustomStorageService } from '../custom-storage/custom-storage.service';
import {
  GET_OFFERS,
  GET_OFFER_BADGE,
  PURCHASES_OFFER,
  REACTIVATE_OFFER_URL,
} from '../../shared/constants/urls';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  constructor(
    private readonly http: HttpClient,
    private readonly storageService: CustomStorageService
  ) {}

  getHeader() {
    const headers = new HttpHeaders({
      authorization: 'bearer ' + this.storageService.getToken(),
    });
    return headers;
  }

  getOffers() {
    return this.http.get(GET_OFFERS, { headers: this.getHeader() });
  }

  getOfferBadge() {
    return this.http.get(GET_OFFER_BADGE, { headers: this.getHeader() });
  }

  getOfferId(id) {
    const query = '?id=' + id;
    return this.http.get(GET_OFFERS + query, { headers: this.getHeader() });
  }

  activateOffer(offerId: any) {
    const enterprise = this.storageService.getEnterprise().id;
    const objPurchased = {
      enterprise,
      offer: offerId,
    };
    return this.http.post(PURCHASES_OFFER + '/', objPurchased, {
      headers: this.getHeader(),
    });
  }

  disabledOffer(subscription_id: any) {
    return this.http.put(PURCHASES_OFFER + '/disable/' + subscription_id, '', {
      headers: this.getHeader(),
    });
  }

  reactiveOffer(subscription_id: any) {
    return this.http.put(REACTIVATE_OFFER_URL + subscription_id, '', {
      headers: this.getHeader(),
    });
  }

  getOfferHistory() {
    const enterpriseId = this.storageService.getEnterprise().id;
    return this.http.get(
      PURCHASES_OFFER + '?enterpriseId=' + enterpriseId + '&onlyActive=true',
      { headers: this.getHeader() }
    );
  }

  getCurrentOffer() {
    const enterpriseId = this.storageService.getEnterprise().id;
    return this.http.get(PURCHASES_OFFER + '?enterpriseId=' + enterpriseId, {
      headers: this.getHeader(),
    });
  }
}
